const consoleError = console.error;
const SUPPRESSED_WARNINGS = ['onLeftKeyPress', 'onRightKeyPress'];

console.error = process.env.NODE_ENV === 'production'
  ? () => {}
  : function filterWarnings(msg, ...args) {
      if (!SUPPRESSED_WARNINGS.some((entry) => args[0].includes(entry))) {
        consoleError(msg, ...args);
      }
    };